import * as z from 'zod';

import { fileQuerySchema } from '@/_schemas/file';

export const brandQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string().min(3),
  icon: z.array(fileQuerySchema).nullish(),
  agreement_statement: z.string().nullish(),
  invoice_disclaimer: z.string().nullish(),
  agreement_logo: z.array(fileQuerySchema).nullish(),
});

export type BrandQueryLinkerSchema = z.infer<typeof brandQueryLinkerSchema>;
